/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-11-28 17:02:22
 * @LastEditors: hongye
 * @LastEditTime: 2025-06-05 18:02:15
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import registerPlugin from './plugins/index'
import store from '@/store/store'
import directive from '@/directive/index'
import registerCompoent from '@/components/index'
import { lang } from './utils'
import request from '@/service/request'
import { insertBonreeScript } from './utils/bonree'
import './assets/iconfont/iconfont.css'
import '@/assets/style/common.less'
import VueWechatTitle from 'vue-wechat-title' // 动态修改title
import echarts from '@/plugins/charts'
import { message } from 'ant-design-vue'

// 尽早初始化 Bonree SDK，确保页面加载性能数据采集完整
insertBonreeScript()

// 获取 Vite 环境变量
const {NODE_ENV, VITE_APP_DATAFINDER_ID} = import.meta.env;
window.collectEvent('init', {
  app_id: Number(VITE_APP_DATAFINDER_ID),
  channel_domain: 'https://snssdk.jntexpress.id',  // 替换为私有部署部署服务地址, 
  disable_sdk_monitor: true, //用于禁止SDK启动后自身监控事件 onload 的上报
  log: NODE_ENV !== 'production' ? true : false,
  spa: true,
  autotrack: true
});
window.collectEvent('start')

/**
 * message提示组件的全局配置
 */
message.config({
  duration: 2, // 持续时间
  maxCount: 1, // 最大显示数, 超过限制时，最早的消息会被自动关闭
  top: '70px' // 到页面顶部距离
})

const app = createApp(App)
const packageList = [router, store, registerCompoent, directive, VueWechatTitle]
packageList.forEach((p) => app.use(p))

//按需注册全局组件
registerPlugin(app)
app.config.globalProperties.$lang = lang
app.config.globalProperties.$req = request
app.config.globalProperties.$echarts = echarts
// 全局拦截警告
app.config.warnHandler = (msg, instance, trace) => {
  // 忽略警告或记录到其他地方
  console.warn(`Custom Vue warning: ${msg}`);
};
app.provide('$echarts', echarts)
app.mount('#app')
